import type { Sort } from '@/stores/sorting.ts';

export function sortToQuery(sort: Sort | null | undefined): { sort?: string } {
    if (!sort?.key) {
        return {};
    }
    return { sort: `${sort.key}:${sort.direction || 'asc'}` };
}
